import React, {Fragment} from 'react'
const Message = (props) => {
    const {message}= props
    return (  
        <Fragment>
        <div className="bg-red-100 border-red-400 text-red-700 px-4 py-3 rounded max-w-md mx-auto mt-6 text-center">
        <strong className="font-bold">Error!</strong>
        <span className="block">{message}</span>
    </div>
    </Fragment>

    );
}
 
export default Message;